<template>
  <div class="forbidden-page">
    <div class="centered">
      <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>403</h1>
      <h3>{{$t('page403.info')}}</h3>
      <h5><a :href="$route.query.path">{{ $route.query.path }}</a></h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "forbidden",
  components: {
  }
};
</script>
<style lang="scss">
.forbidden-page {
  .full-page > .content,
  .centered {
    min-height: calc(100vh - 160px);
  }
  .not-found-icon {
    margin-right: 10px;
  }
  .centered {
    h1,
    i {
      font-size: 50px;
    }
    p {
      font-size: 20px;
    }
    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
  }
}
</style>
